import { render, staticRenderFns } from "./PlayerConfigDrmConfig.vue?vue&type=template&id=6634a01c&scoped=true&"
import script from "./PlayerConfigDrmConfig.vue?vue&type=script&lang=js&"
export * from "./PlayerConfigDrmConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634a01c",
  null
  
)

export default component.exports